import { useEffect, useState } from 'react';

const readIsNarrowerThan = (breakpointPx: number): boolean =>
  typeof window !== 'undefined' && window.innerWidth < breakpointPx;

export const useIsViewportNarrowerThan = (breakpointPx: number): boolean => {
  const [isNarrower, setIsNarrower] = useState<boolean>(() =>
    readIsNarrowerThan(breakpointPx)
  );

  useEffect(() => {
    const handleResize = (): void =>
      setIsNarrower((previous) => {
        const next = readIsNarrowerThan(breakpointPx);
        return previous === next ? previous : next;
      });

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpointPx]);

  return isNarrower;
};
